import { React } from 'react'

import { APPNAME, APPVERSION } from '../../main.js'

import './MainFooter.css'
import './MMainFooter.css'
import '../../main.css'

export default function MainFooter(props) {

  const eventStyle = (props.useEventStyle == true)
    ? { backgroundColor: 'var(--event_color_tilebg)', color: 'var(--event_color_stdtextontile)' }
    : {}

  return (
    <div className='mainfooterdiv' style={eventStyle}>
      <footer className='site-footer' style={eventStyle}>
        <div className='footer-inner'>
          <div className='footer-grid'>
            <div className='footer-brand'>
              <h3>Helferzeit</h3>
              <p>Hand in Hand organisieren – das Portal für ehrenamtliche Helfer und gemeinnützige Organisationen.</p>
            </div>
            <div className='footer-col'>
              <h4>Plattform</h4>
              <a href='/events/public'>Öffentliche Events</a>
              <a href='/profil'>Mein Profil</a>
            </div>
            <div className='footer-col'>
              <h4>Helferzeit</h4>
              <a href='https://www.helferzeit.de/rechtliches'>Rechtliches</a>
              <a href='/faq'>FAQ &amp; Handbuch</a>
              <a href='https://www.helferzeit.de/support'>Support</a>
              <a href='https://www.helferzeit.de'>helferzeit.de</a>
            </div>
          </div>
          <div className='footer-bottom'>
            <span>© 2026 <a href='https://www.helferzeit.de'>Helferzeit.de</a> – ein Projekt der <a href="https://tonetwork.de" target="_blank" rel="noopener noreferrer">ToNetwork UG</a> <span className='footer_versioninfo'>({APPNAME + '_v' + APPVERSION})</span></span>
          </div>
        </div>
      </footer>
    </div>
  )
}
